<template>
    <v-dialog v-model="show" :persistent="false" :width="width">
      <v-card class="confirm-dialog" :class="`${customClass}`" >
        <v-card-title>
          <span :class="`title1`"><lang :t="title"></lang></span>
          <v-spacer></v-spacer>
          <v-btn icon light @click="closeModal">
            <v-icon>mdi-close</v-icon>
          </v-btn> 
        </v-card-title>
        <v-card-text> 
          <slot></slot>
        </v-card-text>
        <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text @click="closeModal()" :disabled="isSaving"><lang :t="cancelTxt"></lang></v-btn>
            <v-btn elevation="0" light rounded color="themeColor" @click="agreed" :loading="isSaving"
              ><lang :t="okTxt"></lang
            ></v-btn>
        </v-card-actions>
      </v-card>
  </v-dialog>
</template>

<script>
  export default {
    name: 'ConfirmDialog',
    data(){
      return {
        show: false
      }
    },
    props:{
      title: {
        type: String,
        required: true
      },
      actionCancelTxt: {
        type: String
      },
      actionOkTxt:{
        type: String
      },
      visible: {
        type: Boolean,
        default: false
      },
      customClass:{
        type: String,
        default: ''
      },
      width:{
        type: String
      }
    },
    methods:{
      closeModal(){
        this.show = false;
        this.$emit('close');
      },
      agreed(){
        this.$emit('ok');
      }
    },
    created(){

    },
    computed:{
      cancelTxt(){
        if(!this.actionCancelTxt) return this.$i18n.t('GLOBAL-BTN-CANCEL');
        return this.actionCancelTxt;
      },
      okTxt(){
        if(!this.actionOkTxt) return this.$i18n.t('GLOBAL-BTN-OK');
        return this.actionOkTxt;
      }

    },
    watch: {
      visible:{
        handler(value){
          this.show = value;
        }
      },
      show:{
        handler(value){
          if(value) return;
          this.$emit('hide');
        }
      }
    }

  }
</script>

<style lang="scss" scoped>

</style>
